import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { co } from '@fullcalendar/core/internal-common';
import { ApiService } from 'src/app/services/api.service';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm!: FormGroup;
  isSubmitting = false;
  isMailSent: boolean = false;
  apiErrorMessage: string = '';
  successMessage: string = '';
  invalidCredentials: boolean = false;
  errorMessage: string = "";

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.forgotPasswordForm.get('email')?.valueChanges.subscribe(() => {
      const control = this.forgotPasswordForm.get('email');
      if (control?.hasError('errorMessage')) {
        const errors = { ...control.errors };
        delete errors['errorMessage'];
        control.setErrors(Object.keys(errors).length ? errors : null);
      }
    });
  }

  initForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, this.email]]
    });

  }

  sendResetLink() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.apiErrorMessage = '';
    this.successMessage = '';
    this.errorMessage = '';
    const payload = {
      mail: this.forgotPasswordForm.value.email.toLowerCase().trim()
    };

    this.apiService.fetchResetKey(payload).subscribe({
      next: (res) => {
        this.resetMailPage();
      },
      error: (err) => {
        this.isSubmitting = false;
         const errorMessage =
          err?.error?.title;

        this.forgotPasswordForm.get('email')?.setErrors({
          errorMessage: errorMessage
        });
      }
    });

  }

  resetMailPage() {
    sessionStorage.setItem('mailSent', 'true');
    this.router.navigate(['/reset-mail-sent'], {
      replaceUrl: true
    });
  }


  login() {
    this.router.navigate(['/login']);
  }

  email(c: AbstractControl) {
    const v = c.value || '';
    const emailRegex = /^[^\s@]+@[^\s@]+\.(com|in|org)$/;

    return emailRegex.test(v) ? null : { email: true };
  }
}
